import type { ConfigurationContextValue } from "./ConfigurationContext";
import brandLogo from "./logos/georgia-web-co-logo.png";
import brandMark from "./logos/georgia-web-co-mark.png";

/** Full wordmark — use on light backgrounds */
export const defaultLightModeLogo = brandLogo;
/** Mark only — use on dark backgrounds (wordmark navy text won't show on navy) */
export const defaultDarkModeLogo = brandMark;

export const defaultCurrency = "USD";

export const defaultTitle = "Georgia Web Co CRM";

/** Local service business types (Georgia SMB focus). */
export const defaultCompanySectors = [
  { value: "auto-repair", label: "Auto Repair" },
  { value: "cleaning", label: "Cleaning" },
  { value: "landscaping", label: "Landscaping" },
  { value: "hvac", label: "HVAC" },
  { value: "plumbing", label: "Plumbing" },
  { value: "roofing", label: "Roofing" },
  { value: "contracting", label: "Contracting" },
  { value: "beauty", label: "Beauty / Barber" },
  { value: "real-estate", label: "Real Estate" },
  { value: "professional-services", label: "Professional Services" },
  { value: "other", label: "Other" },
];

/** Simple 5-stage pipeline for local service jobs/quotes. */
export const defaultDealStages = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "quote-sent", label: "Quote sent" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "service", label: "Service" },
  { value: "repair", label: "Repair" },
  { value: "install", label: "Install" },
  { value: "maintenance", label: "Maintenance" },
  { value: "quote", label: "Quote" },
  { value: "other", label: "Other" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "Active", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
  { value: "follow-up", label: "Follow-up" },
  { value: "visit", label: "Visit" },
  { value: "other", label: "Other" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
